import { render, staticRenderFns } from "./cogsTextOnly.vue?vue&type=template&id=a85ceb76&scoped=true"
import script from "./cogsTextOnly.vue?vue&type=script&lang=js"
export * from "./cogsTextOnly.vue?vue&type=script&lang=js"
import style0 from "./cogsTextOnly.vue?vue&type=style&index=0&id=a85ceb76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85ceb76",
  null
  
)

export default component.exports